import { Box, Container as ContainerBase, Stack } from '@mui/material';
import { SimpleHeader } from '@/components/SimpleHeader';
import { Footer } from '@/components/Footer';

import { Faq } from '@/pages/public/pricing/Faq';

import Reviews from './Reviews';
import { FastCheckoutContent } from '../editor/FastCheckoutContent/FastCheckoutContent';

function Container({ sx = {}, ...props }) {
	return (
		<ContainerBase
			maxWidth="false"
			sx={{
				maxWidth: '1024px',
				padding: 0,
				px: { xs: '20px', md: 0 },

				...sx
			}}
			{...props}
		/>
	);
}

function FastCheckout() {
	return (
		<Box
			sx={{
				position: 'fixed',
				inset: 0,
				zIndex: 1200,
				overflowY: 'auto',
				background: 'white'
			}}
		>
			<SimpleHeader />

			<Stack
				component="main"
				sx={{
					marginTop: { xs: '24px', md: '40px' },
					gap: { xs: '64px', md: '80px' }
				}}
			>
				<Box component="section">
					<Container>
						<FastCheckoutContent />
					</Container>
				</Box>

				<Reviews />

				<Box width="100%">
					<Container>
						<Faq
							container={false}
							titleProps={{
								fontSize: { xs: 20, md: 40 },
								fontWeight: 500
							}}
							titleWrapperProps={{
								textAlign: 'left'
							}}
							bottomPattern={false}
							pt={{ xs: 3, md: 6 }}
							pb={{ xs: '8px', md: '84px' }}
						/>
					</Container>
				</Box>
			</Stack>

			<Footer prefooter={false} languageSelector={false} />
		</Box>
	);
}

export default FastCheckout;
